import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        centered ? "md:flex-col md:items-center text-center" : "md:justify-between"
      }`}
    >
      <div className={centered ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <div
            className={`mb-3 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.22em] text-primary-600 ${
              centered ? "justify-center" : ""
            }`}
          >
            <span className="h-px w-6 bg-primary-400" />
            {eyebrow}
          </div>
        )}
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}